import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=c82af9e4&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=c82af9e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82af9e4",
  null
  
)

export default component.exports